import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Gallery } from '@patternfly/react-core';

import useAPI from 'services/useAPI';
import ContentPage from 'components/ContentView/ContentPage/ContentPage';
import ProviderClientCard from '../Assets/components/Cards/ProviderClientCard';
import IothubDeviceCard from '../Assets/components/Cards/IothubDeviceCard';
import ProvisioningCard from '../Assets/components/Cards/ProvisioningCard';
import './gallery.css';
import createQueryRequest from 'services/createQueryRequest';
import { useQuery } from '@tanstack/react-query';
import BreadcrumbSkeleton from 'components/Breadcrumb/BreadcrumbSkeleton';
import { useAuthService } from 'services/AuthService/AuthService';
import { useUserPermissionQuery } from 'services/Permissions/queries';
import { useProviderClient, useProvider } from 'components/Admin/Providers/queries';

const createProviderClientQuery = (api, providerId, providerClientId) => ({
  queryKey: ['provider', providerId, providerClientId],
  queryFn: createQueryRequest(api.core.getProviderClient),
  enabled: providerId != null && providerClientId != null
});

export const ProviderClientName = ({ providerId, providerClientId }) => {
  const api = useAPI();
  const providerClientQuery = useQuery(createProviderClientQuery(api, providerId, providerClientId));
  const name = providerClientQuery.data?.displayName ?? '';
  return providerClientQuery.isLoading ? <BreadcrumbSkeleton /> : name;
};

const AdminProviderClient = ({ breadcrumbs }) => {
  const { providerId, providerClientId } = useParams();
  const { user } = useAuthService();

  const providerClientQuery = useProviderClient(providerId, providerClientId);
  const refreshProviderClient = () => {
    providerClientQuery.query.refetch();
  };

  const providerQuery = useProvider(providerId);

  const providerClientPermissionQuery = useUserPermissionQuery(user?.userId, 'provider_client', providerId + '::' + providerClientId, 'manage');

  const providerClient = useMemo(() => {
    if (providerQuery?.provider && providerClientQuery?.providerClient) {
      return {
        provider: providerQuery?.provider,
        ...providerClientQuery?.providerClient
      };
    }
    return {};
  }, [providerQuery?.provider, providerClientQuery?.providerClient]);

  return (
    <ContentPage breadcrumb={breadcrumbs} help={'admin/providers/clients/view'}>
      <div style={{ height: '100%', overflow: 'auto' }}>
        <Gallery
          hasGutter
          className={'detail-gallery'}
        >
          <ProviderClientCard providerClientInfo={providerClient} isLoading={providerClientQuery?.query?.pending || providerQuery?.query?.pending} hasEdit={providerClientPermissionQuery?.data?.[0]?.result ?? false} updateProviderClientInfo={refreshProviderClient}/>
          <IothubDeviceCard iotDeviceInfo={providerClient?.providerData} isLoading={providerClientQuery?.query?.pending || providerQuery?.query?.pending}/>
          <ProvisioningCard provisionData={providerClient?.provisioningData} isLoading={providerClientQuery?.query?.pending || providerQuery?.query?.pending} />
        </Gallery>
      </div>
    </ContentPage>
  );
};

export default AdminProviderClient;
